export default __webpack_public_path__ + "static/JayGeiger-95d7d2cc32b6c10cca525e18b1cea1ed.jpg";